import { useEffect, useRef, useState } from 'react'

export const useCountdown = (initialSeconds: number, stopCounting?: boolean, rerender?: number | string) => {
    const [seconds, setSeconds] = useState(initialSeconds)
    const requestFrame = useRef(0)
    const firstCall = useRef(0)
    const deltaSeconds = useRef(0)

    const isCountdownActive = seconds > 0

    useEffect(() => {
        setSeconds(initialSeconds)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rerender])

    useEffect(() => {
        if (!isCountdownActive || stopCounting) {
            return
        }

        firstCall.current = Date.now()

        const render = () => {
            const tempDeltaSeconds = Math.abs(Math.ceil((firstCall.current - Date.now()) / 1000))

            if (deltaSeconds.current === tempDeltaSeconds) {
                requestFrame.current = requestAnimationFrame(render)
                return
            }

            deltaSeconds.current = tempDeltaSeconds
            setSeconds(initialSeconds - deltaSeconds.current)
            requestFrame.current = requestAnimationFrame(render)
        }

        requestFrame.current = requestAnimationFrame(render)
        return () => cancelAnimationFrame(requestFrame.current)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCountdownActive, stopCounting, rerender])

    return { seconds, isCountdownActive }
}
